var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "talent-eval-user-management" },
    [
      _c(
        "yxt-drawer",
        {
          attrs: {
            visible: _vm.drawerVisible,
            size: "960px",
            title: _vm.$t("pc_gwnl_lbl_userManagement"),
            "before-close": _vm.beforeDrawClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex justify-content-between" },
            [
              _c(
                "div",
                { staticClass: "flex-1" },
                [
                  _c(
                    "yxt-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isImportEval,
                          expression: "!isImportEval",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.addEvalUser },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "pc_gwnl_eval_btn_addTesters" /*添加测评人员*/
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "yxt-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isImportEval,
                          expression: "isImportEval",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.importEvalResult },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "pc_gwnl_global_btn_importEvalResult" /*导入学员测评结果*/
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  !_vm.isImportEval
                    ? _c(
                        "yxt-button",
                        {
                          attrs: { plain: "" },
                          on: { click: _vm.showImportRelation },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.importBatchTitle) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "yxt-button",
                    {
                      attrs: { disabled: !_vm.selection.length, plain: "" },
                      on: { click: _vm.batchDelete },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("pc_gwnl_global_batchDelete" /*批量删除*/)
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("yxt-input", {
                staticStyle: { width: "240px" },
                attrs: {
                  placeholder: _vm.$t("pc_gwnl_global_enterNameOrPosition"),
                  searchable: "",
                  size: "small",
                },
                on: {
                  search: function ($event) {
                    return _vm.search()
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search()
                  },
                },
                model: {
                  value: _vm.keyword,
                  callback: function ($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt16" },
            [
              _c(
                "yxt-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "table",
                  attrs: { data: _vm.list, "row-key": "id" },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("yxt-table-column", {
                    attrs: {
                      type: "selection",
                      "reserve-selection": true,
                      width: "55",
                      selectable: function (row) {
                        return !row.evaluationFinishRate || _vm.isImportEval
                      },
                    },
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      "min-width": "150",
                      prop: "fullName",
                      label: _vm.$t("pc_gwnl_global_lbl_name"),
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("yxtbiz-user-name", {
                              attrs: { name: scope.row.fullName },
                            }),
                            _vm._v(
                              "\n            (" +
                                _vm._s(scope.row.userName) +
                                ")\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      prop: "deptName",
                      label: _vm.$t("pc_gwnl_global_lbl_dept"),
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("yxtbiz-dept-name", {
                              attrs: { name: row.deptName || "--" },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      prop: "positionName",
                      label: _vm.$t("pc_gwnl_global_lbl_position"),
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.positionName || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  !_vm.isImportEval
                    ? _c("yxt-table-column", {
                        attrs: {
                          prop: "evaluationFinishRate",
                          label: _vm.$t("pc_gwnl_eval_lbl_evalFinishRate"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.evaluationFinishRate >= 0
                                          ? Math.floor(
                                              scope.row.evaluationFinishRate *
                                                10000
                                            ) /
                                              100 +
                                              "%"
                                          : "--"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          393778503
                        ),
                      })
                    : _vm._e(),
                  _c("yxt-table-column", {
                    attrs: {
                      width: "160px",
                      label: _vm.$t("pc_gwnl_global_lbl_operate"),
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.evaluationFinishRate || _vm.isImportEval
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "yxt-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteUser(
                                              scope.row.userId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("pc_gwnl_lbl_delete")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v("\n              --\n            "),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "clearfix" },
                [
                  _c("yxtbiz-eval-pager", {
                    attrs: {
                      total: _vm.pager.total,
                      page: _vm.pager.offset,
                      limit: _vm.pager.limit,
                      layout: "total, prev, pager, next",
                    },
                    on: {
                      "update:total": function ($event) {
                        return _vm.$set(_vm.pager, "total", $event)
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pager, "offset", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.pager, "limit", $event)
                      },
                      pagination: _vm.getList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.addUserVisible
        ? _c("yxtbiz-eval-select-thirdparty-user", {
            attrs: {
              "show-model": _vm.eType === 1,
              visible: _vm.addUserVisible,
              "get-list": _vm.getUsers,
              "is-peer": _vm.isPeer,
              "function-code": _vm.functionCode,
              "data-permission-code": _vm.dataPermission,
            },
            on: {
              "update:visible": function ($event) {
                _vm.addUserVisible = $event
              },
              selected: _vm.handleSelectedUsers,
            },
          })
        : _vm._e(),
      _c("yxtbiz-eval-import-drawer", {
        ref: "importRelation",
        attrs: {
          title: _vm.importBatchTitle,
          "temp-url": _vm.tempUrl,
          i18n: "",
          "import-methods": _vm.importMethods,
          id: _vm.id,
          showNotify: "",
        },
        on: { success: _vm.getList },
      }),
      _c(
        "yxt-drawer",
        {
          attrs: {
            size: "960px",
            title: _vm.$t("pc_gwnl_eval_evalRelationship"),
            visible: _vm.settingVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.settingVisible = $event
            },
            closed: _vm.closeSettingDrawer,
          },
        },
        [
          _c("yxtbiz-eval-evaluator-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.userNotify,
                expression: "!userNotify",
              },
            ],
            ref: "multipleTable",
            attrs: {
              datas: _vm.settingData,
              loading: _vm.loading,
              validate: _vm.validate,
              multiple: false,
              scene: _vm.scene,
              "data-permission-code": _vm.evaluatorDataPermission,
              "function-code": _vm.functionCode,
              isSelfTest: _vm.isSelfTest,
              relationList: _vm.relationList,
            },
          }),
          _vm.userNotify
            ? _c("eval-notify", {
                ref: "evalNotify",
                attrs: { id: _vm.id, noTiming: "", isUser: "" },
              })
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              !_vm.userNotify
                ? [
                    _c(
                      "yxt-button",
                      {
                        attrs: { plain: "" },
                        on: {
                          click: function ($event) {
                            _vm.settingVisible = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_gwnl_global_btn_cancel")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _c(
                      "yxt-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.submitSetting },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("pc_gwnl_global_btn_next" /* 下一步 */)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "yxt-button",
                      {
                        attrs: { plain: "" },
                        on: {
                          click: function ($event) {
                            _vm.userNotify = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("pc_gwnl_global_btn_previous" /* 上一步 */)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _c(
                      "yxt-button",
                      {
                        attrs: { type: "primary", loading: _vm.loadingNotify },
                        on: { click: _vm.postUsersNotify },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("pc_gwnl_global_btn_confirm" /* 确认 */)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c("yxtbiz-eval-import-eval-score", {
        attrs: {
          "evaluation-id": _vm.id,
          "eval-type": _vm.evalType,
          "project-id": _vm.projectId,
          source: _vm.source,
          title: _vm.$t("pc_gwnl_global_eval_score"),
          visible: _vm.importScoreVisible,
          module: "hw",
        },
        on: {
          "update:visible": function ($event) {
            _vm.importScoreVisible = $event
          },
          success: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }